import React, { Component } from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import classnames from 'classnames';
import * as productSearchActions from './productSearchActions';
import {GlobalHeader, BackButton} from '../common/GlobalHeader';
import DateSelectionTray from './DateSelectionTray';
import moment from 'moment';
import { DayPicker } from 'react-dates';
import Flash from '../components/Flash';
import {PSEUDO_CITY, STATION} from './stationTypeConstants';
import getStationsFromStationResult from '../utils/getStationsFromStationResult';
import './calendar.scss'

class DateSearchContainer extends Component {

  constructor(props) {
    super(props);
    this.state = {flash: null};
    this.preventPastDate = this.preventPastDate.bind(this);
    this.onSelectDate = this.onSelectDate.bind(this);
    this.goToSummary = this.goToSummary.bind(this);
    this.headerSummary = this.headerSummary.bind(this);
  }

  componentWillMount() {
    this.preventPastDate();
    this.props.actions.calendarParameters();
  }

  preventPastDate() {
    let {selected_date} = this.props;

    if(!selected_date) { return; }

    let today = moment().startOf('day');

    if(today.isAfter(selected_date, 'day')) {
      this.setTravelDate(today.toDate());
    }
  }

  onSelectDate(date) {
    this.setTravelDate(date);
    this.props.actions.broadcastSelectedDepartureDate();
  }

  setTravelDate(date) {
    if(moment.isMoment(date)) {
      if (isBeforeToday(date)) return;

      if (isClosed(date, this.props.closed_dates, this.props.closed_weekdays)) {
        this.setState({
          flash: {
            error: getClosedMessage(date, this.props.closed_dates, this.props.closed_weekdays)
          }
        });
        return;
      } else {
        this.setState({flash: null});
      }

      let origins = getStationsFromStationResult(this.props.origin_station_result);
      let destinations = getStationsFromStationResult(this.props.destination_station_result);

      this.props.actions.selectTravelDate(date);
      this.props.actions.priceDate(
        origins,
        destinations,
        date.format('YYYY-MM-DD'),
        this.props.passenger_quantity
      );
    } else {
      this.props.actions.selectTravelDate(null);
    }
  }

  goToSummary(date) {
    this.props.actions.openProductSearch();
  }

  headerSummary() {
    var label = (direction) => {
      let result = this.props[`${direction}_station_result`];
      return result.result_type === PSEUDO_CITY ? result.title : result.code;
    };

    return `${label('origin')} > ${label('destination')}`;
  }

  renderFlash() {
    if (this.state.flash && this.state.flash.error) {
      return <Flash error={this.state.flash.error} />;
    }
  }

  render() {
    let today = new Date();

    return (
      <div className="page-layout date-search-container">
        <GlobalHeader
          leftComponent={<BackButton onClick={this.goToSummary} />}
          title='Select a Departure Date'
          subTitle={this.headerSummary()} />

        {this.renderFlash()}

        <div className="page-layout-body" style={{overflow: 'hidden'}}>
          <DayPicker
            numberOfMonths={12}
            orientation={'verticalScrollable'}
            onDayClick={this.onSelectDate}
            renderDay={buildDays(this.props.selected_date, this.props.dates_with_flights, this.props.closed_dates, this.props.closed_weekdays)}
            hideKeyboardShortcutsPanel={true}
            daySize={50}
          />
          <div className="calendar-legend">
            <div>
              <span>Underlined</span> = By-the-seat availability. Charter any time.
            </div>
          </div>
        </div>
        <DateSelectionTray
          onDateChange={this.onSelectDate}
        />
      </div>
    )
  }
}

const isSelected = (day, selectedDate) => (!!selectedDate && day.isSame(selectedDate, 'day'));
const isDisabled = (day, closedDates, closedWeekdays) => {
  return isBeforeToday(day) || isClosed(day, closedDates, closedWeekdays);
};
const isBeforeToday = (day) => day.isBefore(moment(), 'day');
const isClosed = (date, closedDates, closedWeekdays) => {
  return isDateClosed(date, closedDates) || isWeekdayClosed(date, closedWeekdays);
};
const isWeekdayClosed = (date, closedWeekdays) => !!closedWeekdays[date.format('dddd')];
const isDateClosed = (date, closedDates) => {
  return closedDates.includes(date.format('YYYY-MM-DD'));
}
const getClosedMessage = (date, closedDates, closedWeekdays) => {
  if (isDateClosed(date, closedDates)) {
    return 'Please choose another day. None of your selected stations are open on this day.';
  } else {
    return closedWeekdays[date.format('dddd')];
  }
}

const buildDays = (selectedDate, datesWithFlights, closedDates, closedWeekdays) => {
  let lastIndexFound = 0;

  const hasFlight = day => {
    let flightDateIndex = _.indexOf(datesWithFlights, day.format('YYYY-MM-DD'), lastIndexFound);
    lastIndexFound = flightDateIndex >= 0 ? flightDateIndex : lastIndexFound;
    return flightDateIndex >= 0;
  }

  return day => {
    return (
      <Day
        day={day}
        isSelected={isSelected(day, selectedDate)}
        isDisabled={isDisabled(day, closedDates, closedWeekdays)}
        hasFlight={hasFlight(day)}  />
    );
  }
}

const Day = ({day, isSelected, isDisabled, hasFlight}) => {
  return (
    <div className={classnames(
      {
        'is-selected': isSelected,
        'is-disabled': isDisabled,
        'has-flight': hasFlight
      }
    )}>
      <span>{day.format('D')}</span>
    </div>
  );
}

function mapStateToProps(state, ownProps) {
  return {
    selected_date: state.productSearch.travel_date_selection,
    origin_station_result: state.productSearch.origin_station_result,
    destination_station_result: state.productSearch.destination_station_result,
    passenger_quantity: state.productSearch.passenger_quantity,
    dates_with_flights: state.productSearch.dates_with_flights,
    closed_weekdays: state.productSearch.closed_weekdays,
    closed_dates: state.productSearch.closed_dates
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(productSearchActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DateSearchContainer);
